"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var ChatUnread = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_ChatUnread_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 3.25c0-.041 0-.082-.003-.122A2.992 2.992 0 0 1 15 5.236v4.016a1.75 1.75 0 0 1-1.75 1.75H8.49c-.927 0-1.818.369-2.474 1.025L4 14.043v-1.791c0-.69-.56-1.25-1.25-1.25A1.75 1.75 0 0 1 1 9.252V3.25c0-.966.784-1.75 1.75-1.75h7.651c.232-.401.555-.744.94-1H2.75A2.75 2.75 0 0 0 0 3.25v6.002a2.75 2.75 0 0 0 2.75 2.75.25.25 0 0 1 .25.25v2.998a.5.5 0 0 0 .854.354l2.869-2.87a2.5 2.5 0 0 1 1.768-.732h4.759A2.75 2.75 0 0 0 16 9.252V3.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 3a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_ChatUnread_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = ChatUnread;
exports["default"] = _default;